import React, { useState } from 'react';
import marked from 'marked';
import Button from ':src/components/Button';

export type IncrementalProps = {
  items: string[];
  label: string;
};

const Incremental = ({ items, label }: IncrementalProps) => {
  const [itemsRevealed, setItemsRevealed] = useState<string[]>([]);
  const [nextItemIndex, setNextItemIndex] = useState(0);

  const areAllItemsRevealed = itemsRevealed.length === items.length;

  const revealItem = () => {
    setItemsRevealed([...itemsRevealed, items[nextItemIndex]]);
    setNextItemIndex(nextItemIndex + 1);
  };
  return (
    <>
      <Button
        className="mb-3"
        onClick={revealItem}
        disabled={areAllItemsRevealed}
      >
        {areAllItemsRevealed
          ? `No more ${label}s`
          : `Reveal a ${label} (${itemsRevealed.length}/${items.length})`}
      </Button>
      {itemsRevealed.length > 0 && (
        <ul className="list-none divide-y">
          {itemsRevealed.map((item, i) => (
            // eslint-disable-next-line react/no-array-index-key, react/no-danger
            <li
              key={i}
              dangerouslySetInnerHTML={{ __html: marked(item) }}
              className="pt-4"
            />
          ))}
        </ul>
      )}
    </>
  );
};

export default Incremental;
